export default {
  namespaced: true,
  state: {
    dialogs: {
      signIn: false,
      share: false,
      profitlossDeteleAll: false,
    },
  },
  getters: {
    dialogs: (state) => state.dialogs,
  },
  mutations: {
    toggleDialog(state, { dialog, visible }) {
      state.dialogs[dialog] =
        visible === undefined ? !state.dialogs[dialog] : visible;
    },
  },
  actions: {
    toggleDialog: ({ commit }, dialog, visible) =>
      commit("toggleDialog", { dialog, visible }),
  },
};
